import React, { Component } from "react";
import { Button, Checkbox, Input, Modal, Radio, List, Select,InputNumber ,message} from "antd";
import { withRouter } from "react-router-dom";
import Apis from "src/js/apis/api";
import DownloadApis from "src/js/apis/download";
import Storage from "src/js/storage";
import SubsetApis from "src/js/apis/subset";
// 公用folder
import AllFolders  from 'commons/AllFolders/index'
import Utils from "src/js/utils";
import "./index.css";
const { Option } = Select;
@withRouter
class ReferenceTableResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ResultVisible: false,
      detailData: {},
      showDetailForm: false,
      taxType: "Original",
      isCheckAll: false,
      checkedObj: {},
      defaultCheckedList: [],
      searchParams: props.searchParams || {},
      searchValues: props.searchValues || {},
      currentPage: 1,
      totalNumbers: 0,
      resultLists: props.resultLists || [],
      pageSize: 16,
      AllPages: 0,
      checkOne: props.checkOne === true ? true : false,
      showCite: props.showCite === true ? true : false,

      showCiteModal: false,
      currentData: {},
      showAddSubset: props.showAddSubset === true ? true : false,
      showDeleteSubset: props.showDeleteSubset === true ? true : false,
      // showExportFile: props.showExportFile === true ? true : false,

      // askLoading:false,
      folderOperateShow:false
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      searchParams: nextProps.searchParams,
      searchAllValues: nextProps.searchAllValues
    });
    if (this.props.checkOne) {
      this.setState({
        checkOne: true
      });
    }
    if (nextProps.showDeleteSubset !== this.props.showDeleteSubset) {
      this.setState({
        showDeleteSubset: nextProps.showDeleteSubset
      });
    }
    if (nextProps.showAddSubset !== this.props.showAddSubset) {
      this.setState({
        showAddSubset: nextProps.showAddSubset
      });
    }
  }
  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    if (this.props.checkOne) {
      this.setState({
        checkOne: true
      });
    }
  }
  downloadFile = file => {
    let href = "/api" + file;
    let idx = file.lastIndexOf("/");

    let name = file.substring(idx + 1, file.length);
    var a = document.createElement("a");
    a.setAttribute("href", href);
    a.setAttribute("download", name);
    a.setAttribute("id", "downloadFileA");
    a.setAttribute("name", "name");
    // 防止反复添加
    if (document.getElementById("downloadFileA")) {
      document.body.removeChild(document.getElementById("downloadFileA"));
    }
    document.body.appendChild(a);

    a.click();
  };
  downReference = async () => {
    let { checkedObj, currentJournalType } = this.state;
    let reference_ids = Object.keys(checkedObj);
    let params = {
      reference_ids,
      ref_journal: currentJournalType
    };

    let downBack = await Apis.downloadRefFiles(params);
    if (downBack.result) {
      this.setState(
        {
          conopUrl: downBack.result
        },
        () => {
          this.downloadFile(downBack.result);
        }
      );
    } else {
      Modal.error({
        content: "download failed"
      });
    }
  };

  // 未走接口的本地显示删除
  deleteFun = async () => {
    let { checkedObj, resultLists, isCheckAll } = this.state;
    let rankValue = Object.values(checkedObj).sort(
      Utils.objComparison("index")
    );
    let deleteArrays = [];
    rankValue.map((item, index) => {
      deleteArrays.push(item.item.ref_id);
    });

    deleteArrays.map((item, index) => {
      resultLists.splice(checkedObj[item].index, 1);
      delete checkedObj[item];
    });

    if (resultLists.length < 11) {
      if (this.state.currentPage == this.state.AllPages) {
        if (resultLists.length == 0) {
          this.toPre();
        }
      } else if (this.state.currentPage == 1) {
        this.toFirst();
      } else {
        this.toPre();
      }
    }

    this.setState(
      {
        checkedObj,
        resultLists,
        isCheckAll: false
      },
      () => {
        this.props.changeCheckSelected(checkedObj, resultLists);
      }
    );
  };
  deleteSubset = async () => {
    let that = this;
    Modal.confirm({
      title: "please choose",
      content: "Do you want to delete the subsets?",
      async onOk() {
        let { checkedObj, resultLists } = that.state;

        let rankValue = Object.values(checkedObj).sort(
          Utils.objComparison("index")
        );
        let deleteArrays = [];
        rankValue.map((item, index) => {
          deleteArrays.push(item.item.ref_id);
        });

        let uid = Storage.getItem("gbdbid");

        let params = {
          uid,
          assetstype: 1,
          ids: deleteArrays
        };

        let deleteAssetsBack = await SubsetApis.deleteAssets(params);
        if (deleteAssetsBack.result) {
          deleteArrays.map((item, index) => {
            resultLists.splice(checkedObj[item].index, 1);
            delete checkedObj[item];
          });
          if (resultLists.length < 11) {
            if (that.state.currentPage == that.state.AllPages) {
              if (resultLists.length == 0) {
                that.toPre();
              } else {
              }
            } else if (that.state.currentPage == 1) {
              that.toFirst();
            } else {
              that.toPre();
            }
          }

          that.setState(
            {
              checkedObj,
              resultLists,
              isCheckAll: false
            },
            () => {
              if (that.props.changeCheckSelected) {
                that.props.changeCheckSelected(checkedObj, resultLists);
              }
            }
          );
        } else {
          Modal.error({
            title: "This is an error message",
            content: deleteAssetsBack.error
          });
        }
      },
      onCancel() {
      
      }
    });
  };
  addSubset = async () => {
    if(Storage.getItem("token") == undefined){
      Modal.error({
        title:"Please login first",
        content:"Only after the login can collect data!!!"
      })
      return
    }
    this.setState({
      folderOperateShow:true
    },()=>{

    })
    // let { checkedObj } = this.state;

    // let uid = Storage.getItem("gbdbid");

    // let params = {
    //   uid,
    //   assetstype: 1,

    //   ids: Object.keys(checkedObj)
    // };
    // let collectBack = await SubsetApis.collectAssets(params);
    // if (collectBack.result) {
    //   Modal.success({
    //     title: "This is an successful message",
    //     content: "successfully added "
    //   });
    // } else {
    //   Modal.error({
    //     title: "This is an error message",
    //     content: collectBack.error
    //   });
    // }
  };
  searchSubset = async searchParams => {
    this.setState(
      {
        askLoading: true
      },
      async () => {
        let pageSize = 11;
        let searchCondition = {};
        let pageParams = {
          page: this.state.currentPage,
          pageSize
        };
        Object.assign(searchCondition, searchParams, pageParams);
        let folderResBack = await SubsetApis.getAssetsInfolder(searchCondition);
        if (folderResBack.error) {
          this.setState({
            askLoading: undefined
          });
          const modal = Modal.error({
            title: "This is an error message",
            content: folderResBack.error
          });
          setTimeout(() => {
            modal.destroy();
          }, 3000);
        } else {
          let result = folderResBack.result;
          let totalNumbers = folderResBack.total;
          // let { pageSize } = this.state;
          let AllPages = Math.ceil(totalNumbers / pageSize);

          this.setState(
            {
              resultLists: result,
              totalNumbers,
              AllPages,
              askLoading: false
              // conditions: searchAllValues
            },
            () => {}
          );
        }
      }
    );
  };

  searchReferenceDatas = async (searchParams, searchAllValues,type, page) => {
    if(page==undefined){
      this.setState({
        currentPage:1
      })
      page=1
    }
    
    this.setState(
      {
        askLoading: true
      },
      async () => {
        let searchResult = [];
        let searchCondition = {};
        let pageParams = {
          page: page,
          pageSize: this.state.pageSize
        };

        Object.assign(searchCondition, searchParams, pageParams);

        searchResult = await Apis.searchReference(searchCondition);

        if (searchResult.error) {
          this.setState({
            askLoading: undefined
          });
          Modal.error({
            title: "This is an error message",
            content: searchResult.error
          });
        } else if (searchResult.result) {
          let result = searchResult.result;
          let totalNumbers = searchResult.total;
          let { pageSize } = this.state;
          let AllPages = Math.ceil(totalNumbers / pageSize);
          this.setState(
            {
              resultLists: result,
              totalNumbers,
              AllPages,
              conditions: searchAllValues,
              askLoading: false
            },
            () => {}
          );
        }
      }
    );
  };

  changePage = value => {
    this.setState(
      {
        currentPage: value,
        isCheckAll: false,
        askLoading: undefined,
        checkedObj: {},
        resultLists: []
      },
      () => {
        let { searchParams, values, optionType } = this.state;
        let pathname = this.props.location.pathname;
        if (pathname === "/subset") {
          this.searchSubset(searchParams, values, optionType);
        } else {
          this.searchReferenceDatas(searchParams, values,optionType, this.state.currentPage);
        }
      }
    );
  };
  gotoPage = e => {
    if (e.keyCode === 13) {
      var page = parseInt(e.target.value);

      let { AllPages } = this.state;
      if (page < 1 || page > AllPages) {
         message.warning("Please enter the correct page number");
        return;
      } else {
        this.setState(
          {
            currentPage: page
          },
          () => {
            this.changePage(this.state.currentPage);
          }
        );
      }
    }
  };
  gotoPages=()=>{
    let pageDom=document.querySelector('.searchResult-select input')
    if(pageDom){
      let pageValue=pageDom.value
      if(pageValue){
        let  page= parseInt(pageValue);
        let { AllPages } = this.state;
        if (page < 1 || page > AllPages) {
           message.warning("Please enter the correct page number");
          return;
        } else {
          this.setState(
            {
              currentPage: page
            },
            () => {
              this.changePage(this.state.currentPage);
            }
          );
        }

      }
    }

  }
  toFirst = e => {
    this.setState(
      {
        currentPage: 1
      },
      () => {
        this.changePage(this.state.currentPage);
      }
    );
  };

  toPre = e => {
    if (this.state.currentPage === 1) {
      return;
    } else {
      this.setState(
        {
          currentPage: this.state.currentPage - 1
        },
        () => {
          this.changePage(this.state.currentPage);
        }
      );
    }
  };

  toNext = e => {
    if (this.state.currentPage === this.state.AllPages) {
      return;
    } else {
      this.setState(
        {
          currentPage: this.state.currentPage + 1
        },
        () => {
          this.changePage(this.state.currentPage);
        }
      );
    }
  };

  CheckAll = e => {
    let { resultLists, checkedObj } = this.state;
    if (e.target.checked === true) {
      this.setState(
        {
          isCheckAll: true
        },
        () => {
          resultLists.map((item, index) => {
            checkedObj[item.ref_id] = {
              item,
              index
            };
          });
          this.setState(
            {
              checkedObj
            },
            () => {
              let { checkedObj, resultLists } = this.state;
              this.props.changeCheckSelected(checkedObj, resultLists);
            }
          );
        }
      );
    } else {
      this.setState(
        {
          isCheckAll: false
        },
        () => {
          this.setState(
            {
              checkedObj: {}
            },
            () => {
              let { checkedObj, resultLists } = this.state;
              this.props.changeCheckSelected(checkedObj, resultLists);
            }
          );
        }
      );
    }
  };

  itemCheckbox = (item, index, event) => {
    if (this.props.location.search) {
      this.setState(
        {
          isSearch: true
        },
        () => {
          // this.props.history.push('')
        }
      );
    } else {
      this.setState({
        isSearch: false
      });
    }

    let { resultLists, checkedObj } = this.state;
    let nameId = Number(event.target.name);
    if (event.target.checked === true) {
      checkedObj[nameId] = {
        item,
        index
      };
    } else if (event.target.checked === false && checkedObj[nameId]) {
      delete checkedObj[nameId];
    }

    let checkedLength = Object.keys(checkedObj).length;

    this.setState(
      {
        isCheckAll: checkedLength === resultLists.length
      },
      () => {
        if (this.props.checkOne) {
          let datavalue = event.target.datavalue;

          this.props.checkRefOne(datavalue);
        } else {
          let { checkedObj, resultLists } = this.state;
          this.props.changeCheckSelected(checkedObj, resultLists);
        }
      }
    );
  };

  getDetail = detailItem => {
    this.props.getDetail(detailItem);
  };
  getCite = detailItem => {
    // if(this.props.getCite){
    //   this.props.getCite(detailItem)
    // }
    this.setState({
      showCiteModal: true,
      currentData: detailItem
    });
  };
  CiteOk = () => {
    this.setState({
      showCiteModal: false
    });
  };
  CiteCancel = () => {
    this.setState({
      showCiteModal: false
    });
  };

  downloadCiteFile = (blobUrl, type, name) => {
   
    let suffixs = {
      BibTeX: ".txt",
      EndNote: ".evn",
      RefMan: ".ris",
      NoteFirst: ".txt",
      NoteExpress: ".net"
    };
    if (name == "") {
      name = suffixs[type];
    }
    var a = document.createElement("a");
    a.setAttribute("href", blobUrl);
    a.setAttribute("download", name);
    a.setAttribute("id", "downloadFileA");
    a.setAttribute("name", "name");
    // 防止反复添加
    if (document.getElementById("downloadFileA")) {
      document.body.removeChild(document.getElementById("downloadFileA"));
    }
    document.body.appendChild(a);

    a.click();
  };
  referenceCiteDownload = async type => {
    let { currentData } = this.state;
    let refId = "";
    if (JSON.stringify(currentData) !== {}) {
      refId = currentData.ref_id;
    }

    let allParams = {
      ref_id: refId,
      type
    };
    let downBack = await DownloadApis.referenceCiteDownload(allParams);
 
    if (downBack && downBack.data && downBack.data.error) {
      Modal.error({
        content: downBack.data.error
      });
    } else {
      const blob = new Blob([downBack.data]);
      let blobUrl = window.URL.createObjectURL(blob);
      let name = "";
      if (
        downBack &&
        downBack.headers &&
        downBack.headers["content-disposition"]
      ) {
        let allname = downBack.headers["content-disposition"].split(";");
        if (allname.length > 0) {
          name = allname[1].split("=")[1];
          if(name.indexOf("%20") != -1){
            name=name.split("%20")[0]
          }
        }
      }
      this.downloadCiteFile(blobUrl, type, name);
    }
  };
  changeJournalType = value => {
    this.setState({
      currentJournalType: value
    });
  };
  resetCheckData = () => {
    this.setState({
      currentPage: 1,
      isCheckAll: false,
      askLoading: undefined,
      checkedObj: {}
    });
  };

  // 
  handlefolderOk = () => {
    this.setState({
      folderOperateShow: false
    });
  };
  handlefolderCancel = () => {
    this.setState({
      folderOperateShow: false
    });
  };

  goAddReference = () => {
    let url = "/reference/add";
    let params = `${url}`;
    const w = window.open("about:blank");
    w.location.href = params;
  };

  render() {
    let { resultLists } = this.state;

    let {
      currentPage,

      AllPages,
      isCheckAll,
      checkedObj,

      checkOne,
      currentData
    } = this.state;
    return (
      <div id="SearchResult" className="SearchResult-refsearch">
        {/*  taxResult-main */}
        <div className="">
          <div className="content">
            {resultLists.length > 0 && this.state.askLoading == false ? (
              <table>
                <tbody>
                  <tr className="head">
                    {checkOne ? (
                      <td></td>
                    ) : (
                      <td className="check">
                        <Checkbox
                          onChange={e => this.CheckAll(e, "ref_id")}
                          checked={isCheckAll}
                        ></Checkbox>
                      </td>
                    )}

                    <td className="ref-id">Ref ID</td>
                    <td>Authors</td>
                    <td>Pub year</td>
                    <td>Title</td>
                    <td>Pages</td>
                    <td>Accessibility</td>
                    <td>Details</td>
                    <td>Cite</td>
                  </tr>

                  {resultLists.map((item, index) => {
                    return (
                      <tr key={item.ref_id} className="row">
                        {checkOne ? (
                          <td className="check">
                            <Radio
                              name={item.ref_id.toString()}
                              onChange={e => this.itemCheckbox(item, index, e)}
                              datavalue={item}
                              checked={checkedObj.hasOwnProperty(item.ref_id)}
                            ></Radio>
                          </td>
                        ) : (
                          <td className="check">
                            <Checkbox
                              name={item.ref_id.toString()}
                              onChange={e => this.itemCheckbox(item, index, e)}
                              checked={checkedObj.hasOwnProperty(item.ref_id)}
                            ></Checkbox>
                          </td>
                        )}

                        <td>{item.ref_id}</td>
                        <td>{item.ref_authors}</td>

                        <td>{item.ref_publication_year}</td>
                        <td>{item.ref_title}</td>
                        <td>{`${item.ref_page_number_begin} - ${item.ref_page_number_end}`}</td>
                        <td>{item.accessibility === 0 ? "open" : "private"}</td>

                        <td className="btn">
                          <Button
                            type="gbdb"
                            onClick={() => this.getDetail(item)}
                          >
                            <div>Details</div>
                          </Button>
                        </td>
                        <td className="btn">
                          <Button
                            type="gbdb"
                            onClick={() => this.getCite(item)}
                          >
                            <div>Cite</div>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : this.state.askLoading == true ? (
              <div className="tablelist-no-resource">
                 <div id="allResult">
                      <div className="allLoader">
                        <div className="loader-inner ball-spin-fade-loader">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        <span>Loading...</span>
                      </div>
                    </div>
              </div>
            ) : resultLists.length === 0 && this.state.askLoading == false ? (
              <div>
                <div className="tablelist-no-resource">No Resource</div>
                <span className="sectionGeography-tutude-btn">
                  <Button type="gbdb" onClick={this.goAddReference}>
                    <p>Add Reference</p>
                  </Button>
                </span>
               </div>
            ) : (
              <div className="tablelist-no-resource"></div>
            )}
          </div>
          {resultLists.length > 0 ? (
            <div className="footer">
              <div className="first" onClick={this.toFirst}>
                First
              </div>
              <div className="pre" onClick={this.toPre}>
                Pre
              </div>
              <div className="pages">{`${currentPage}/${AllPages}pages`}</div>
              <div className="next" onClick={this.toNext}>
                Next
              </div>

              <div className="page-input">
              <InputNumber
                  className="searchResult-select"
                  onKeyDown={this.gotoPage}
                  min={1}
                ></InputNumber>
                 <span className="goto" onClick={this.gotoPages}>Goto</span>
              </div>
            </div>
          ) : null}
        </div>
        <div className="subset-file-btns">
          {/* {this.state.showExportFile === true ? (
            <Select
              title="Select Journal Type"
              className="reference-download-select"
              placeholder="Select Journal Type"
              onChange={this.changeJournalType}
            >
              <Option value="Acta Palaeontologica Sinica">
                Acta Palaeontologica Sinica
              </Option>
              <Option value="Journal of Stratigraphy">
                Journal of Stratigraphy
              </Option>
              <Option value="Science China">Science China</Option>
              <Option value="Chinese Science Bulletin">
                Chinese Science Bulletin
              </Option>
              <Option value="Palaeoworld">Palaeoworld</Option>
              <Option selected="selected" value="Palaeontology">
                Palaeontology
              </Option>
              <Option value="Paleobiology">Paleobiology</Option>
              <Option value="Journal of Paleontology">
                Journal of Paleontology
              </Option>
              <Option value="Palaeogeography, Palaeoclimatology, Palaeoecology">
                Palaeogeography, Palaeoclimatology, Palaeoecology
              </Option>
              <Option value="Geology">Geology</Option>
              <Option value="PNAS">PNAS</Option>
            </Select>
          ) : null}
          {this.state.showExportFile === true ? (
            <Button
              type="gbdb"
              title="Please select the file first"
              onClick={this.downReference}
              disabled={JSON.stringify(this.state.checkedObj) === "{}"}
            >
              <p title="Please select the file first">Export Reference</p>
            </Button>
          ) : null} */}

          {
          // Storage.getItem("token") !== undefined &&
          this.state.showAddSubset === true ? (
            <Button
              type="gbdb"
              disabled={Object.keys(checkedObj).length <= 0}
              onClick={this.addSubset}
            >
              Add to data subsets
            </Button>
          ) : null}
          {Storage.getItem("token") !== undefined &&
          this.state.showDeleteSubset === true ? (
            <Button
              type="gbdb"
              onClick={this.deleteSubset}
              disabled={Object.keys(checkedObj).length <= 0}
            >
              Delete subset
            </Button>
          ) : null}
        </div>
        <Modal
          title=""
          destroyOnClose
          visible={this.state.showCiteModal}
          className="citeModal"
          width="60%"
          footer={null}
          // header={null}
          onOk={this.CiteOk}
          onCancel={this.CiteCancel}
        >
          <List
            size="large"
            header={<div>Cite</div>}
            footer={
              <div className="ref-cite-link">
                <span>Inbound links: </span>
                <span onClick={() => this.referenceCiteDownload("BibTeX")}>
                  BibTeX
                </span>
                <span onClick={() => this.referenceCiteDownload("EndNote")}>
                  EndNote
                </span>
                <span onClick={() => this.referenceCiteDownload("RefMan")}>
                  RefMan
                </span>
                <span onClick={() => this.referenceCiteDownload("NoteFirst")}>
                  NoteFirst
                </span>
                <span onClick={() => this.referenceCiteDownload("NoteExpress")}>
                  NoteExpress
                </span>
              </div>
            }
            bordered
          >
            <List.Item className="link-citelist-item">
              <div className="ref-cite-item">
                <div className="ref-citeitem-title">GB/T 7714</div>
                <div className="ref-citeitem-detail">
                  {JSON.stringify(currentData) !== "" ? (
                    <div>
                      {currentData.ref_authors !== "" ? (
                        <span>{currentData.ref_authors}.</span>
                      ) : null}
                      {currentData.ref_title !== "" ? (
                        <span>{currentData.ref_title}.</span>
                      ) : null}
                      {currentData.ref_journal !== "" ? (
                        <span>{currentData.ref_journal},</span>
                      ) : null}
                      {currentData.ref_publication_year !== "" ? (
                        <span>{currentData.ref_publication_year},</span>
                      ) : null}
                      {currentData.ref_Journal_volume !== "" ? (
                        <span>{currentData.ref_Journal_volume}</span>
                      ) : null}
                      {currentData.ref_volume_no !== "" ? (
                        <span>{`(${currentData.ref_volume_no}):`}</span>
                      ) : null}
                      <span>
                        {currentData.ref_page_number_begin}-
                        {currentData.ref_page_number_end}
                      </span>
                      {currentData.ref_publisher !== "" ? (
                        <span>{currentData.ref_publisher}.</span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </List.Item>
            <List.Item className="link-citelist-item">
              <div className="ref-cite-item">
                <div className="ref-citeitem-title">MLA</div>
                <div className="ref-citeitem-detail">
                  {JSON.stringify(currentData) !== "" ? (
                    <div>
                      {currentData.ref_authors !== "" ? (
                        <span>{currentData.ref_authors}.</span>
                      ) : null}
                      {currentData.ref_title !== "" ? (
                        <span>{currentData.ref_title}</span>
                      ) : null}
                      {currentData.ref_journal !== "" ? (
                        <span>{currentData.ref_journal}</span>
                      ) : null}
                      {currentData.ref_Journal_volume !== "" ? (
                        <span>{currentData.ref_Journal_volume}.</span>
                      ) : null}
                      {currentData.ref_volume_no !== "" ? (
                        <span>{`${currentData.ref_volume_no}`}</span>
                      ) : null}

                      {currentData.ref_publication_year !== "" ? (
                        <span>{`(${currentData.ref_publication_year}):`}</span>
                      ) : null}
                      <span>
                        {currentData.ref_page_number_begin}-
                        {currentData.ref_page_number_end}
                      </span>
                      {currentData.ref_publisher !== "" ? (
                        <span>{currentData.ref_publisher}.</span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </List.Item>
            <List.Item className="link-citelist-item">
              <div className="ref-cite-item">
                <div className="ref-citeitem-title">APA</div>
                <div className="ref-citeitem-detail">
                  {JSON.stringify(currentData) !== "" ? (
                    <div>
                      {currentData.ref_authors !== "" ? (
                        <span>{currentData.ref_authors}.</span>
                      ) : null}

                      {currentData.ref_publication_year !== "" ? (
                        <span>{`(${currentData.ref_publication_year})`}</span>
                      ) : null}

                      {currentData.ref_title !== "" ? (
                        <span>{currentData.ref_title}</span>
                      ) : null}
                      {currentData.ref_journal !== "" ? (
                        <span>{currentData.ref_journal},</span>
                      ) : null}
                      {currentData.ref_Journal_volume !== "" ? (
                        <span>{currentData.ref_Journal_volume}</span>
                      ) : null}
                      {currentData.ref_volume_no !== "" ? (
                        <span>{`(${currentData.ref_volume_no}),`}</span>
                      ) : null}
                      <span>
                        {currentData.ref_page_number_begin}-
                        {currentData.ref_page_number_end}
                      </span>
                      {currentData.ref_publisher !== "" ? (
                        <span>{currentData.ref_publisher}.</span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </List.Item>
          </List>
        </Modal>
        <Modal
          title="Folder"
          destroyOnClose
          visible={this.state.folderOperateShow}
          className="subset-movemodal folder-common-modal clearfix"
          width="30%"
          onOk={this.handlefolderOk}
          onCancel={this.handlefolderCancel}
          footer={null}
        >
          <AllFolders
           folderType="reference"
           checkedObj={this.state.checkedObj}
           closeCommonFolder={this.handlefolderOk}
          >
          </AllFolders>
        </Modal>
      </div>
    );
  }
}

export default ReferenceTableResult;
